import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as fromBase from '../reducers';
import * as menus from '../actions/menus.actions';
import * as user from '../../auth/actions/user';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, share, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { withPredicateFrom } from '../../core/helpers/rx-pipes';
import * as fromAuth from '../../auth/reducers';
import { MenusService } from '../services/menus.service';
var MenusEffects = /** @class */ (function () {
    function MenusEffects(actions$, menusSvc, store) {
        var _this = this;
        this.actions$ = actions$;
        this.menusSvc = menusSvc;
        this.store = store;
        this.initMenus$ = this.actions$.ofType(menus.INIT)
            .pipe(withLatestFrom(this.store.pipe(select(fromBase.isMenusTtlExpired)), function (action, isMenusTtlExpired) { return ({ forceRefresh: action.forceRefresh, isMenusTtlExpired: isMenusTtlExpired }); }), switchMap(function (data) {
            var actionsArr = [];
            if (data.forceRefresh || data.isMenusTtlExpired) {
                actionsArr.push(new menus.Get());
            }
            else {
                actionsArr.push(new menus.GetSkipped());
            }
            return of.apply(void 0, actionsArr);
        }));
        this.getMenuItems$ = this.actions$
            .pipe(ofType(menus.GET), withPredicateFrom(this.store
            .pipe(select(fromAuth.isCustomerSelected))), withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), function (state, customerId) { return customerId; }), switchMap(function (customerId) {
            return _this.menusSvc.getMenusEntities(customerId)
                .pipe(map(function (res) { return new menus.GetSuccess(res); }), catchError(function (e) { return of(new menus.GetFailed(e)); }));
        }));
        this.getItemsOnLogin$ = this.actions$
            .pipe(ofType(user.GET_SUCCESS), withPredicateFrom(this.store
            .pipe(select(fromAuth.isCustomerSelected))), map(function (_) { return new menus.Init(true); }), share());
        this.getOnLangChange$ = this.actions$
            .pipe(ofType(user.SET_LANGUAGE), switchMap(function () {
            return _this.actions$
                .ofType(user.SET_SUCCESS)
                .pipe(take(1));
        }), map(function (_) { return new menus.Init(true); }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MenusEffects.prototype, "initMenus$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MenusEffects.prototype, "getMenuItems$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MenusEffects.prototype, "getItemsOnLogin$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], MenusEffects.prototype, "getOnLangChange$", void 0);
    return MenusEffects;
}());
export { MenusEffects };
